import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { IndentRequestDetails } from './IndentRequestDetails';

export interface IndentRequestHeaderParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface IndentRequestHeader { 

    id?:number;
    indentNo?:any;
    indentDate:any;
    requestBy:string;
    requestTenantId:string;
    requesterBranchId:string;
    requesterDepartmentId:string;
    approverTenantId:string;
    approverBranchId:string;
    approverDepartmentId:string;
    indentStatus:string;
    createdBy:string;
    createdDate:any;
    branchId: string;
    tenantId: string;  
    sendRequestflag:boolean;
    approvalflag:boolean;
    internalDepartmentId:any;
    pharmacyId:any;
    phIndentRequestDetDto: IndentRequestDetails[];
    indentType?: string | null;
    senderLocationId?: number | null;

            parameters ?: IndentRequestHeaderParameter[];
links ?: any;
}


export abstract class IndentRequestHeaderData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<any[]>;
    abstract create(url: string, data: any): Observable<any[]>;
    abstract update(url: string, data: any): Observable<any>;
}
